import { ContentService } from 'services/content.service';
import {
  Inject,
  OnInit,
  Component, Input,
} from 'ng-metadata/core';

import commentHtml from './comment.html';
import './comment.scss';

@Component({
  selector: 'gw-portal-comment',
  template: commentHtml,
})
export class CommentComponent implements OnInit {
  public commentForm;
  public fullName = '';
  public organization = '';
  public email = '';
  public phone = '';
  public comment = '';
  public submitting = false;
  public success = null;

  @Input() destination;
  @Input() portal;

  constructor(
    @Inject(ContentService) private contentService: ContentService,
  ) {}

  ngOnInit() {
  }

  async submitForm() {
    if (this.commentForm.$invalid) {
      return;
    }

    this.submitting = true;
    this.contentService.sendComments({
      destination: this.destination,
      full_name: this.fullName,
      organization: this.organization,
      email: this.email,
      phone: this.phone,
      portal: this.portal,
      comment: this.comment,
    }).then(() => {
      this.clearForm(true);
    }).catch(() => {
      this.clearForm(false);
    }).finally(() => {
      this.submitting = false;
    });
  }

  editing() {
    if (!this.submitting) {
      this.success = null;
    }
  }

  clearForm(success: boolean) {
    if (success) {
      this.fullName = '';
      this.organization = '';
      this.email = '';
      this.phone = '';
      this.comment = '';

      this.commentForm.$setPristine();
      this.commentForm.$setUntouched();
    }
    this.success = success;
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/comment/comment.component.ts